import classNames from "classnames";
import { FC, HTMLAttributes, ReactNode } from "react";

type LegendItemProps = {
  icon: ReactNode;
  label: ReactNode;
};

const LegendItem: FC<LegendItemProps> = ({ icon, label }) => {
  return (
    <div className="flex items-center md:gap-2 gap-1">
      <div className="flex h-3.5 w-3.5 shrink-0 items-center justify-center">{icon}</div>
      <div className="text-font-hover text-xs md:text-base font-medium whitespace-nowrap">{label}</div>
    </div>
  );
};

const Legend: FC<{ items: LegendItemProps[] } & HTMLAttributes<HTMLDivElement>> = ({
  items,
  className,
  ...props
}) => {
  return (
    <div
      className={classNames(
        "font-poppins flex flex-wrap items-center gap-x-2 md:gap-x-6 bg-background-default! gap-y-2 py-3! justify-between px-4!",
        className,
      )}
      {...props}
    >
      {items.map((item, index) => (
        <LegendItem key={index} {...item} />
      ))}
    </div>
  );
};

export default Legend;
